import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { type IntlShape } from 'react-intl';
import StoreBadgeBase from '../StoreBadgeBase';

type AppStoreProps = {
  height: number;
  noReferrer?: boolean;
  languageRegionCode: LanguageRegionCode;
  className?: string;
  intl: IntlShape;
};

export const APP_STORE_URL_MAP: { [key in LanguageRegionCode]: string } = {
  ['da-DK']: 'https://alltrails.io/0DQOp3xSKqb',
  ['nl-NL']: 'https://alltrails.io/bnhhPBCSKqb',
  ['en-US']: 'https://alltrails.io/ujRkr9MGmgb',
  ['en-GB']: 'https://alltrails.io/em2gG5fTKqb',
  ['fr-FR']: 'https://alltrails.io/DKsdICPLmgb',
  ['de-DE']: 'https://alltrails.io/qytSKQVLmgb',
  ['it-IT']: 'https://alltrails.io/atgRTHZSKqb',
  ['nb-NO']: 'https://alltrails.io/IW34a43SKqb',
  ['pl-PL']: 'https://alltrails.io/OiILL66SKqb',
  ['pt-PT']: 'https://alltrails.io/nmIprq9SKqb',
  ['pt-BR']: 'https://alltrails.io/tSbcKObTKqb',
  ['es-ES']: 'https://alltrails.io/ig3zPxYLmgb',
  ['es-MX']: 'https://alltrails.io/bCsh8BtSKqb',
  ['sv-SE']: 'https://alltrails.io/qUv17XdTKqb'
};

const AppStore = ({ height, languageRegionCode, className, noReferrer = true, intl }: AppStoreProps) => {
  const src = require(`./apple-app-store-${languageRegionCode}.svg`).default;

  return (
    <StoreBadgeBase
      altText={intl.formatMessage({ defaultMessage: 'Download the AllTrails application on the App Store' })}
      src={src}
      storeUrl={APP_STORE_URL_MAP[languageRegionCode]}
      height={height}
      dataTestId="apple-app"
      className={className}
      noReferrer={noReferrer}
    />
  );
};

export default AppStore;
